<script>
import {
  TRADING_ORDER_STATUS,
  TRADING_ORDER_VWEIFY_STATUS,
  PAY_WAY,
  getValue
} from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import { getCategory, getTradeList, tradeConfirm } from "@/api/tradingCenter";

export default {
  computed: {
    TRADING_ORDER_STATUS() {
      return TRADING_ORDER_STATUS;
    },
    TRADING_ORDER_VWEIFY_STATUS() {
      return TRADING_ORDER_VWEIFY_STATUS;
    },
    PAY_WAY() {
      return PAY_WAY;
    },
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        categoryId: "",
        status: "",
        payway: "",
        keyword: "",
        page: 1,
        limit: 10
      },
      dialogFormVisible: false, // 新增 or 编辑的弹框
      dialogType: "",
      rules: {
        status: [{ required: true, message: "状态不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        status: "", // 状态：3-交易完成，4-交易取消
        remark: "" // 备注信息
      },
      btnLoading: false,
      categoryOption: []
    };
  },
  created() {
    this.getList();
    this.getCategory();
  },
  watch: {},
  mounted() {},
  methods: {
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getTradeList(this.listQuery)
        .then(response => {
          this.list = (response.data && response.data.data) || [];
          this.total = response.data.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 查询交易类别
    getCategory() {
      getCategory().then(resp => {
        if (resp && resp.code === 0) {
          this.categoryOption = resp.data;
        }
      });
    },

    /**
     * 切换状态
     * @param status
     * @param editObj
     */
    checkDialogFormVisible(status, editObj = {}) {
      if (editObj && Object.keys(editObj).length !== 0) {
        this.form.id = editObj.id;
      }
      this.dialogFormVisible = status;
      if (!status) {
        this.form.id = 0;
        this.$refs.form.resetFields();
      }
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = this.form;
          this.btnLoading = true;
          tradeConfirm(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>

<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.categoryId"
        placeholder="交易类别"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in categoryOption"
          :key="item.key"
          :label="item.code"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.payway"
        placeholder="支付方式"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PAY_WAY"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in TRADING_ORDER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {})"
        >新增</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="id" label="编号" width="80"> </el-table-column>
      <el-table-column prop="name" label="用户名称">
        <template slot-scope="scope">
          {{ scope.row.user.name }}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="用户电话" width="180">
        <template slot-scope="scope">
          {{ scope.row.user.mobile }}
        </template>
      </el-table-column>
      <el-table-column prop="email" label="用户邮箱" width="180">
        <template slot-scope="scope">
          {{ scope.row.user.email }}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="地区">
        <template slot-scope="scope">
          {{ scope.row.category.code }}
        </template>
      </el-table-column>

      <el-table-column prop="deal_price" label="购买价格" width="100">
        <template slot-scope="scope">
          {{ scope.row.deal_price }}{{ scope.row.category.currency }}/吨
        </template>
      </el-table-column>
      <el-table-column prop="deal_ton" label="购买数量">
        <template slot-scope="scope"> {{ scope.row.deal_ton }}吨 </template>
      </el-table-column>
      <el-table-column prop="amount" label="总金额">
        <template slot-scope="scope">
          {{ scope.row.amount }}{{ scope.row.category.currency }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ getValue(TRADING_ORDER_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="pay_way" label="付款方式"> </el-table-column>
      <el-table-column prop="pay_account" label="付款账户">
        <template slot-scope="scope">
          {{
            scope.row.pay_account && JSON.parse(scope.row.pay_account).bankName
          }}
        </template>
      </el-table-column>
      <el-table-column prop="pay_amount" label="付款金额" width="100">
        <template slot-scope="scope">
          {{ scope.row.pay_amount }}{{ scope.row.pay_currency }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="opt_user" label="跟进客服">
        <template slot-scope="scope">
          {{ scope.row.cusser && scope.row.cusser.nickname }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="创建时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.created_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="修改时间"
        min-width="200"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.updated_at) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="checkDialogFormVisible(true, scope.row)"
            style="margin-right: 8px"
            >确认交易</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    确认交易-->
    <el-dialog
      title="确认交易"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="checkDialogFormVisible(false, {})"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="状态" prop="region">
          <el-select
            v-model="form.status"
            placeholder="请选择"
            style="width: 200px"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in TRADING_ORDER_VWEIFY_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注信息" prop="remark">
          <el-input
            v-model="form.remark"
            placeholder="请输入"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
